export default __webpack_public_path__ + "static/The Home_image 2@2x-c0d86689ef00c6419618bd7862e77f6f.jpg";